export const Header = (props) => {
  return (
    <header id='header' style={{ display: "flex", justifyContent: "center" }}>
      <div className='intro'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-8 col-md-offset-2 intro-text'>
            </div>
          </div>
        </div>
      </div>      
    </header>
  )
}
